<template>
    <div>
        <GNB :title="title"/>

        <div id="header" :class="color">
        	<div id="header-inner-top">
        		<div class="global-header">
        			<h1 class="top-logo"><a :href="$cp">스마트 은평 플랫폼</a></h1>
        			<a href="#header" class="goto-menu-pc" @click="openNav">메뉴열기</a>
        		</div>
        	</div>
        	<div id="header-inner-bm">
        		<div class="title-header">
        			<a href="#header" @click.prevent="goBack" class="goto-back">뒤로가기</a>
        			<h2>{{ title }}</h2>
        			<a href="#header" class="goto-menu menu-btn">메뉴열기</a>
        			<slot name="navigator"></slot>
        		</div>
        	</div>
        </div>

		<GNBPC />
    </div>
</template>

<script>
import GNB from "@/views/layout/GNB.vue"
import GNBPC from "@/views/layout/GNBPC.vue"
import commonConstMixin from '@/store/common.const.mixin'

export default {
	name: 'LayoutHeader',
	props: {
	    title: {
	        type: String,
	        default: "",
	    },
	    color: {
	        type: String,
	        default: "",
	    }
	},
    methods: {
        openNav() {
            document.getElementById("gnb_wrap").style.height = "380px";
        },
        goBack() {
            window.history.go(-1);
            return false;
        }
    },
	components: {
		GNB,
		GNBPC,
	},
    mixins: [commonConstMixin],
}
</script>
